<template>
    <div>
        <template v-if="!loading">
            <template v-if="manager.tipo == 1">
                <LayoutSports :event_id="event_id" :sesion_id="sesion_id" :event="event"/>
            </template>
            <template v-if="manager.tipo == 2">
                <LayoutTeatros :event="event" :entradas="entradas" :event_id="event_id" :sesion_id="sesion_id"/>
            </template>
        </template>
        <template v-else>
            <div class="col-12 text-center" style="height: 600px">
                <LoaderComponent/>
            </div>
        </template>
    </div>
</template>

<script>
    import LayoutSports from './layouts/show/Sports';
    import LayoutTeatros from './layouts/show/Teatros';

    export default {
        props: ['event_id', 'sesion_id'],
        components: {
            LayoutSports,
            LayoutTeatros
        },
        data() {
            return {
                loading: false,
                event: null,
                entradas: null
            }
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            checkVentaCerrada() {
                if (
                    (this.event.venta_online_cerrada || this.event.venta_online_cerrada_definitiva || this.event.status != 1) &&
                    (
                        document.location.href.indexOf('venta_online=test') === -1 &&
                        document.location.href.indexOf('venta_online=preventa-53578') === -1
                    ) &&
                    (
                        this.configuracion.hash_teatro !== "PTNL6tp97mBUGDchX6d4" ||
                        document.location.href.indexOf('venta_online=preventa-53578') === -1
                    )
                ) {
                    return false;
                } else {
                    return true
                }
            }
        },
        created() {
            this.getEvent();
        },
        methods: {
            getEvent() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    event_id: this.event_id,
                    sesion_id: this.sesion_id
                }
        
                this.$store.dispatch(this.config.getVuexAlias('front.events.show'), params).then(res => {
                    this.event = res.data.data;
                    this.entradas = this.event.entradas;
                    this.loading = false;
                    if(this.event.solo_abonados && ! this.event.lfp_id || !this.checkVentaCerrada || this.event.entradas_agotadas_online) {
                        this.$router.push({ name: 'front.eventos.index' });
                    }
                }).catch(error => {
                    this.$router.push({ name: '404page' });
                    console.log(error);
                    this.loading = false;
                });
            },
        }
    }
</script>
